import { details } from "./news";

export const major = [
    {
        id: 1,
        img: "/Images/bundesCup2.png",
        name: "Bundesliga",
        titles: 34,
        firstTitle: "1968-69",
        description: `The Bundesliga was founded in 1963 as Germanys top football league. 
        FC Bayern won its first Bundesliga title in the 1968-69 season and later became the most dominant clup in the 
        competitions history, setting multiple records for consecutive league titles and total championships. `,
        icon: "bi-star-fill"
    },

    {
        id: 2,
        img: "/Images/championsCup.png",
        name: "UEFA Champions League",
        titles: 6,
        firstTitle: "15 / May / 1974",
        description: `Bayern won the UEFA Champions League 6 times. Their first title came on 15 May 1974 against Atletico Madrid
        , starting a historic European era with three consecutive titles ( 1974, 1975, 1976 ). Later truimphs came in 2001, 2013
         and 2020. `,
        icon: "bi-trophy-fill"
    },

    {
        id: 3,
        img: "/Images/pokalCup.png",
        name: "DFB-Pokal",
        titles: 20,
        firstTitle: "13 / June / 1957",
        description: `Bayern has won the DFB-Pokal 20 times, making them the most successful clup in the competitions history. 
        Their first title came on 13 June 1957 after defeating Fortuna Dusseldorf. Bayern continued to dominate the tournament 
        over the decades, with their most recent triumph coming in 2020. `,
        icon: "bi-award-fill"
    },

    {
        id: 4,
        img: "/Images/fifaCup.png",
        name: "FIFA Clup World Cup",
        titles: 2,
        firstTitle: "21 / Decembre / 2013",
        description: ` Bayern has won the FIFA Clup World Cup twice. Their first title came on 21 Decembre 2013 after defeating 
        Raja Casablanca 2-0 in Morocco. The seconde title was secured on 11 February 2021 with a 1-0 victory over 
        Tigres UANL, confirming Bayerns dominance on the global stage. `,
        icon: "bi-trophy-fill"
    },

    {
        id: 5,
        img: "/Images/superCup.png",
        name: "UEFA Super Cup",
        titles: 2,
        firstTitle: "30 / August / 2013",
        description: ` Bayern has won the UEFA Super Cup twice. The competition is played between the winners of the 
        UEFA Champions League and the UEFA Europa League. Bayern secured their first title on 30 August 2013 after 
        defeating Chelsea 5-4 on penalties following a 2-2 draw in Prague. `,
        icon: "bi-award-fill"
    },

    {
        id: 6,
        img: "/Images/DFLcup2.png",
        name: "DFL-Supercup",
        titles: 12,
        firstTitle: "28 / July / 1987",
        description: ` Bayern has won the German Supercup 12 times. the competition is played annually between the Bundesliga champion
        and the DFB-Pokal winner. Bayern secured their first Supercup on 28 July 1987 with a 2-1 victory over Hamburger SV and has 
        since become the most successful clup in the competition. `,
        icon: "bi-star-fill"
    },
]

